import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DashboardStateType } from './types';

const initialState: DashboardStateType = {
  layout: [],
  isUpdate: false,
  visibleShareDashboard: false,

  isVisibleAlert: false,

  resizable: {
    isDragDrop: false,
    isResize: false
  },

  controller: {
    visible: false
  },

  createOrUpdateDashboard: {
    visible: false
  },

  dashboardDelete: {
    visible: false
  },

  dashboards: {
    visible: false
  },

  dashboardUpdate: {
    visible: false
  },

  settings: {
    id: 0,
    visible: false
  },

  widgetDelete: {
    visible: false
  },

  widgetUpdate: {
    visible: false
  }
};

const dashboardSlice = createSlice({
  name: 'dashboard-v2-slice',
  initialState,
  reducers: {
    setLayout: (state, actions: PayloadAction<ReactGridLayout.Layout[]>) => {
      state.layout = actions.payload;
    },
    setUpdate: (state, actions: PayloadAction<boolean>) => {
      state.isUpdate = actions.payload;
    },
    setSettings: (state, actions: PayloadAction<DashboardStateType['settings']>) => {
      state.settings = actions.payload;
    },
    setDashboardsDrawer: (state, actions: PayloadAction<boolean>) => {
      state.dashboards.visible = actions.payload;
    },
    setDashboardDelete: (state, actions: PayloadAction<DashboardStateType['dashboardDelete']>) => {
      state.dashboardDelete = actions.payload;
    },
    setWidgetDelete: (state, actions: PayloadAction<DashboardStateType['widgetDelete']>) => {
      state.widgetDelete = actions.payload;
    },
    setDashboardUpdate: (state, actions: PayloadAction<DashboardStateType['dashboardUpdate']>) => {
      state.dashboardUpdate = actions.payload;
    },
    setWidgetUpdate: (state, actions: PayloadAction<DashboardStateType['widgetUpdate']>) => {
      state.widgetUpdate = actions.payload;
    },
    setActiveDashboard: (state, actions: PayloadAction<DashboardStateType['activeDashboard']>) => {
      state.activeDashboard = actions.payload;
    },
    setRedirectDashboard: (state, actions: PayloadAction<DashboardStateType['activeDashboard']>) => {
      state.redirectDashboard = actions.payload;
    },
    setDashboardController: (state, actions: PayloadAction<DashboardStateType['controller']>) => {
      state.controller = actions.payload;
    },
    setCreateOrUpdateWidget: (state, actions: PayloadAction<DashboardStateType['createOrUpdateDashboard']>) => {
      state.createOrUpdateDashboard = actions.payload;
    },
    setIsVisibleAlert: (state, actions: PayloadAction<boolean>) => {
      state.isVisibleAlert = actions.payload;
    },
    setResizable: (state, actions: PayloadAction<DashboardStateType['resizable']>) => {
      state.resizable = actions.payload;
    },
    setVisibleShareDashboard: (state, actions: PayloadAction<boolean>) => {
      state.visibleShareDashboard = actions.payload;
    }
  }
});

export const dashboardReducer = dashboardSlice.reducer;

export const {
  setUpdate,
  setSettings,
  setDashboardsDrawer,
  setLayout,
  setDashboardDelete,
  setDashboardUpdate,
  setWidgetDelete,
  setWidgetUpdate,
  setActiveDashboard,
  setRedirectDashboard,
  setDashboardController,
  setCreateOrUpdateWidget,
  setIsVisibleAlert,
  setResizable,
  setVisibleShareDashboard
} = dashboardSlice.actions;
